import { EmailCampaignRequestError } from '@/redux/modules/emailCampaigns/emailCampaigns.types';

/**
 * support-api error messages are ready to be shown to users,
 * so they are passed through as-is with a fallback for empty or unknown errors
 */
export const getEmailCampaignRequestErrorMessage = (error: unknown): string => {
    if (error instanceof Error && Boolean(error.message)) {
        return error.message;
    }
    if (typeof error === 'string' && Boolean(error)) {
        return error;
    }
    return EmailCampaignRequestError.Other;
};
